export enum ContactEnum {
  SUPPORT = 1,
  REQUEST_BUDGET = 2,
}